import React from 'react';
import MUIDataTable from 'mui-datatables';
import './DataTable.css';
import { FormGroup, FormLabel, TextField } from '@material-ui/core';

const makeColumnData = (columns) => {
  const columnData = [];
  columns.forEach((currentColumn) => {
    let willFilter = true;
    if (currentColumn.options !== undefined) {
      if (currentColumn.options.filter !== undefined) willFilter = !!currentColumn.options.filter;
    }

    if (currentColumn.numerical) {
      columnData.push({
        name: currentColumn.name,
        options: {
          filter: willFilter,
          filterType: 'custom',

          customFilterListOptions: {
            render: (v) => {
              if (v[0] && v[1]) {
                return `Min ${currentColumn.name}: ${v[0]}, Max ${currentColumn.name}: ${v[1]}`;
              }
              if (v[0]) {
                return `Min ${currentColumn.name}: ${v[0]}`;
              }
              if (v[1]) {
                return `Max ${currentColumn.name}: ${v[1]}`;
              }
              return [];
            },
            update: (filterList, filterPos, index) => {
              if (filterPos === 0) {
                filterList[index].splice(filterPos, 1, '');
              } else if (filterPos === 1) {
                filterList[index].splice(filterPos, 1);
              } else if (filterPos === -1) {
                filterList[index] = [];
              }

              return filterList;
            },
          },
          filterOptions: {
            names: [],
            logic(val, filters) {
              if (filters[0] && filters[1]) {
                return val < filters[0] || val > filters[1];
              }
              if (filters[0]) {
                return val < filters[0];
              }
              if (filters[1]) {
                return val > filters[1];
              }
              return false;
            },
            display: (filterList, onChange, index, column) => (
              <div>
                <FormLabel>
                  {' '}
                  {currentColumn.name}
                  {' '}
                </FormLabel>
                {' '}
                <FormGroup row>
                  <TextField
                    label="min"
                    value={filterList[index][0] || ''}
                    onChange={(event) => {
                      filterList[index][0] = event.target.value;
                      onChange(filterList[index], index, column);
                    }}
                    style={{ width: '45%', marginRight: '5%' }}
                  />
                  {' '}
                  <TextField
                    label="max"
                    value={filterList[index][1] || ''}
                    onChange={(event) => {
                      filterList[index][1] = event.target.value;
                      onChange(filterList[index], index, column);
                    }}
                    style={{ width: '45%' }}
                  />
                  {' '}
                </FormGroup>
                {' '}
              </div>
            ),
          },
          print: false,
        },
      });
    } else if (
      currentColumn.filterable !== undefined
      && !currentColumn.filterable
    ) {
      console.log('filterable', currentColumn);
      columnData.push({
        name: currentColumn.name,
        options: {
          filter: false,
          ...currentColumn.options,
        },
      });
    } else {
      console.log('default', currentColumn);
      columnData.push({
        name: currentColumn.name,
        options: {
          filter: willFilter,
          ...currentColumn.options,
        },
      });
    }
  });
  return columnData;
};

const makeTableData = (data, columns) => {
  if (!data) {
    return {
      columnData: undefined,
      tableData: undefined,
    };
  }

  const tableData = [];
  let columnData = [];

  if (columns) {
    columnData = makeColumnData(columns);
  } else {
    columnData = Object.keys(data[0]);
  }
  data.forEach((event) => {
    tableData.push(Object.values(event));
  });

  return {
    columnData,
    tableData,
  };
};

const DataTable = ({
  tableName, data, error, columns, options,
}) => {
  if (error) {
    return <h4> Error while Loading Table </h4>;
  }

  const { columnData, tableData } = makeTableData(data, columns);
  // console.log("Here", columnData, tableData);
  if (!columnData || !tableData) {
    return <h4> Loading... </h4>;
  }
  return (
    <div className="table-container">
      <MUIDataTable
        title={tableName}
        columns={columnData}
        data={tableData}
        options={{
          sortOrder: { name: 'Event Date', direction: 'desc' },
          overFlowX: 'auto',
          selectableRows: 'none',
          filterType: 'multiselect',
          elevation: 0,
          ...options,
          rowsPerPage: 5,
          downloadOptions: {
            filterOptions: {
              useDisplayedColumnsOnly: true,
              useDisplayedRowsOnly: true,
            },
          },
        }}
      />
      {' '}
    </div>
  );
};

export default DataTable;
